/**
 * The synchronous upload decline (file-handling plan A2, rows 1–9).
 *
 * Every client-upload surface — consume accept, avatar/logo PUT, component
 * sync, certificate attach — refuses an unacceptable upload with HTTP 422 and a
 * top-level `{code, message}` body (`FileDeclinedError.to_dict`, NOT wrapped in
 * FastAPI's `detail`, not camelCased). `message` is the user-facing reason the
 * surface shows inline while the person is still there (A1.1: "tell them
 * immediately").
 */

import { AxiosError } from 'axios';
import { z } from 'zod';

export const FileDeclineSchema = z.object({
  code: z.string().min(1),
  message: z.string().min(1),
});

export type FileDecline = z.infer<typeof FileDeclineSchema>;

/** The decline carried by `error`, or null when `error` is anything else. */
export function extractFileDecline(error: unknown): FileDecline | null {
  if (!(error instanceof AxiosError) || error.response?.status !== 422) return null;
  const parsed = FileDeclineSchema.safeParse(error.response.data);
  return parsed.success ? parsed.data : null;
}
